import React from 'react';

export const PainelAdminProjetosTab = ({ projects }) => {
  return (
    <>
      <div className="flex items-center gap-3 mb-6">
        <span className="text-4xl">🏗️</span>
        <div>
          <h2 className="text-2xl font-bold text-gray-900" data-testid="painel-admin-projetos-title">Projetos de Plantas</h2>
          <p className="text-gray-600" data-testid="painel-admin-projetos-count">{projects.length} projetos cadastrados</p>
        </div>
      </div>

      {projects.length === 0 ? (
        <p className="text-gray-500 text-center py-8" data-testid="painel-admin-projetos-empty">Nenhum projeto cadastrado</p>
      ) : (
        <div className="space-y-3" data-testid="painel-admin-projetos-list">
          {projects.slice(0, 20).map((p) => (
            <div key={p.id} className="border rounded-xl p-4" data-testid={`painel-admin-projeto-card-${p.id}`}>
              <div className="flex justify-between items-start">
                <div>
                  <div className="font-semibold">{p.name}</div>
                  <div className="text-sm text-gray-500">{p.user_name} • {p.user_email}</div>
                </div>
                <div className="text-right">
                  <div className="text-sm text-blue-600">{p.view_count_3d || 0} views 3D</div>
                  <div className="text-xs text-gray-400">{p.floor_plan?.rooms?.length || 0} cômodos</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
};
